import { render, staticRenderFns } from "./Discuss.vue?vue&type=template&id=4f4bd5fe&scoped=true"
import script from "./Discuss.vue?vue&type=script&lang=js"
export * from "./Discuss.vue?vue&type=script&lang=js"
import style0 from "./Discuss.vue?vue&type=style&index=0&id=4f4bd5fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4bd5fe",
  null
  
)

export default component.exports